import {useSignal} from '@preact/signals-react'
import {useSignals} from '@preact/signals-react/runtime'
import {OverlayPanel} from 'primereact/overlaypanel'
import {useEffect, useRef} from 'react'
import {
    overlayTooltipEvent,
    overplayTooltipEventKey,
} from './OverlayTooltipService'
import './style/overlay-tooltip.css'

const OverlayTooltip = () => {
    useSignals()
    const op = useRef(null)
    const content = useSignal()
    const width = useSignal(0)
    useEffect(() => {
        overlayTooltipEvent.on(
            overplayTooltipEventKey.show,
            (target, children) => handleOnShow(target, children),
        )

        return () =>
            overlayTooltipEvent.removeListener(
                overplayTooltipEventKey.show,
                target => handleOnHide(),
            )
    }, [])

    useEffect(() => {
        overlayTooltipEvent.on(overplayTooltipEventKey.hide, target =>
            handleOnHide(),
        )

        return () =>
            overlayTooltipEvent.removeListener(
                overplayTooltipEventKey.hide,
                target => handleOnHide(),
            )
    }, [])
    const handleOnShow = (target, children) => {
        if (op?.current && target && children) {
            const elementWidth = target.target.offsetWidth
            width.value = elementWidth
            content.value = children
            op?.current?.show(target)
        }
    }
    const handleOnHide = () => {
        op.current?.hide()
    }
    return (
        <OverlayPanel
            className="custom-p-overlaypanel"
            id="custom-p-overlaypanel"
            ref={op}
            showCloseIcon={false}
            // style={{width: `${width}px`}}
        >
            {content}
        </OverlayPanel>
    )
}

export default OverlayTooltip
